export const MOCKED_JWT_TOKEN = 'mockedJWT';

export const isRequestMockingEnabled = (): boolean => {
  return process.env.NEXT_PUBLIC_MOCK_AUTH_REQUESTS === 'true';
};

if (isRequestMockingEnabled()) {
  console.log('Auth request mocking enabled');
}

export const setMockedJwtToSessionStorage = (jwt: string): void => {
  sessionStorage.setItem(MOCKED_JWT_TOKEN, jwt);
};

export const getMockedJwtFromSessionStorage = (): string | null => {
  return sessionStorage.getItem(MOCKED_JWT_TOKEN);
};
